
export const CPUModule: React.FC = () => {
  return (
    <>
      <path fill="#1a1a1a" d="M3 3H197V597H3z" />
      <path
        fill="#ccc"
        d="M777 89.94v588H589v-588h188m6-6H583v600h200v-600z"
        transform="translate(-583 -83.94)"
      />
      <circle cx="100" cy="300" r="19.5" fill="#ff931e" />
      <path
        fill="#f15a24"
        d="M683 364.94a19 19 0 11-19 19 19 19 0 0119-19m0-1a20 20 0 1020 20 20 20 0 00-20-20z"
        transform="translate(-583 -83.94)"
      />
      <g fill="#fff" opacity="0.75">
        <circle cx="100" cy="301" r="9.5" />
        <path
          d="M683 375.94a9 9 0 11-9 9 9 9 0 019-9m0-1a10 10 0 1010 10 10 10 0 00-10-10z"
          transform="translate(-583 -83.94)"
        />
      </g>
      <circle cx="100" cy="300" r="9.5" />
      <path
        fill="#f15a24"
        d="M683 374.94a9 9 0 11-9 9 9 9 0 019-9m0-1a10 10 0 1010 10 10 10 0 00-10-10z"
        transform="translate(-583 -83.94)"
      />
      <text
        fill="#fff"
        fontSize="27.77"
        transform="translate(71.28 269.79)"
      >
        CPU
      </text>
      <path fill="#fff" d="M70 300L50 290 50 310 70 300z" />
      <path
        fill="none"
        stroke="#ccc"
        strokeMiterlimit="10"
        strokeWidth="6"
        d="M0 470L200 470"
      />
    </>
  );
};
